"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VideoPlayerElement_1 = __importDefault(require("./VideoPlayerElement"));
var VideoPlayerViewGallery = function (_a) {
    var sources = _a.sources, labels = _a.labels, videoListener = _a.videoListener, mainVideoRef = _a.mainVideoRef, overlay = _a.overlay, children = _a.children;
    return (react_1.default.createElement("div", { className: "ui-video-player-view-gallery" },
        overlay,
        react_1.default.createElement("div", { className: "ui-video-player-view-gallery-left" },
            react_1.default.createElement(VideoPlayerElement_1.default, { videoListener: videoListener, source: sources[0], label: labels ? labels[0] : undefined, videoRef: mainVideoRef }, children)),
        react_1.default.createElement("div", { className: "ui-video-player-view-gallery-right" }, sources.map(function (source, i) { return (i > 0 ? (react_1.default.createElement(VideoPlayerElement_1.default, { videoListener: videoListener, key: source + '-' + (labels ? labels[i] : ''), source: source, label: labels ? labels[i] : undefined })) : null); }))));
};
exports.default = VideoPlayerViewGallery;
